import React, { useState } from 'react';

/**
 * CSV export trigger with in-progress / done / failed feedback.
 * The actual download is performed by the container-supplied async `onExport`.
 *
 * Props: { onExport, label }
 */
const ExportButton = ({ onExport, label = 'Export CSV' }) => {
  const [status, setStatus] = useState('idle'); // idle | busy | done | error

  const handleClick = async () => {
    if (status === 'busy') return;
    setStatus('busy');
    try {
      await onExport();
      setStatus('done');
      setTimeout(() => setStatus('idle'), 2500);
    } catch (e) {
      setStatus('error');
      setTimeout(() => setStatus('idle'), 3500);
    }
  };

  const text =
    status === 'busy' ? 'Exporting…' :
    status === 'done' ? '✓ Exported' :
    status === 'error' ? '⚠ Export failed — retry' :
    `⇩ ${label}`;

  return (
    <button
      type="button"
      className="au-btn au-btn--ghost uv-export"
      data-testid="export-csv"
      data-status={status}
      disabled={status === 'busy'}
      onClick={handleClick}
    >
      {text}
    </button>
  );
};

export default ExportButton;
